import React from "react"
import { useState, useEffect } from "react"
import {
    Box,
    Button,
    FormControl,
    IconButton,
    Stack,
    Autocomplete,
    TextField,
    Checkbox,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
    TablePagination,
    MenuItem,
    Popover,
} from "@mui/material"

import "react-datepicker/dist/react-datepicker.css"
import {
    ApiGetVenueList,
    ApiGetClientEntityByClientGroupId,
    ApiGetShopperList,
    ApiResetBulkAllocation,
    ApiGetResetAllocationList
} from "../../../apiService/Core/Apicall.tsx"
import useDebounce from "../CreateAllocations/UseDebounce.tsx"
// import Dcrage from "./Dcrage.tsx"
import dayjs, { Dayjs } from "dayjs"
import { useDispatch, useSelector } from "react-redux"
import type { RootState } from "../../../global/config/store.ts"
import { toast } from "react-toastify"
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts"
import { CancelOutlined } from "@mui/icons-material"
import { setLoadingFalse, setLoadingTrue } from "../../../global/config/Action/loadingActions.ts"
import store from "../../../global/config/store.ts"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useShopperDetails } from "../../../global/ShopperDetailsUtils.ts"
import Dcrage from "../OrphanAllocation/Dcrage.tsx"

export default function BulkShopperReset() {
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const dispatch = useDispatch()
    const [allocations, setAllocations] = useState<any>([])
    const [venueName, setVenueName] = useState([])
    const [venueNameValue, setVenueNameValue] = useState<any>("")
    const [clientEntityList, setClientEntityList] = useState<any>([])
    const [clientEntityId, setClientEntityId] = useState<any>(null)
    const debouncedClientEntityId = useDebounce(clientEntityId, 500)
    const debouncedVenue = useDebounce(venueNameValue, 700)
    // const [loanData, setLoanData] = useState()
    const [searchText, setSearchText] = useState("");
    // Updated pagination state
    const Clientlist = useSelector((state: RootState) => state.client.clientList)
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
    const [ClientId, setClientId] = useState(null)
    const [selectedAllocations, setSelectedAllocations] = useState<any[]>([]);
    const [selectAll, setSelectAll] = useState(false);
    const [showdateselect, setshowdateselect] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [datalength, setdatalength] = useState<any>(null);
    const [isStartLoading, setisStartLoading] = useState(false);
    const [selectedShopperId, setSelectedShopperId] = useState<string>('');
    const [selectedShopperName, setSelectedShopperName] = useState<string>('');
    const [shopperList, setShopperList] = useState<any[]>([])
    const [searchQuery, setSearchQuery] = useState('')
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedDate, setSelectedDate] = useState<Date>(new Date());
    const { anchorEl, loanData, clickedShopperId, handleShopperDetailsClick, handleClose } = useShopperDetails();

    useEffect(() => {
        if (Clientlist.length > 2) {
            // setSelectedClient(Clientlist[2])
            setClientId(Clientlist[2].clientGroupName)
        }
    }, [Clientlist])

    const fetchShoppers = async (query = '') => {
        try {
            const data = `?offset=0&limit=1000&status=active${query ? `&search=${query}` : ''}`;
            const res = await ApiGetShopperList(data);
            const filtered = res.data.filter(item =>
                item.firstName.trim() !== '' && item.lastName.trim() !== ''
            );
            setShopperList(filtered);
            setShowDropdown(query.length > 0 && filtered.length > 0);
        } catch (error) {
            console.error('Error fetching shoppers:', error);
            toast.error('Failed to load shoppers');
        }
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            fetchShoppers(searchQuery);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchQuery]);

    // const handlePrevMonth = () => {
    //     setCurrentDate((prevDate) => {
    //         const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
    //         const jobMonth = newDate.getMonth() + 1
    //         const jobYear = newDate.getFullYear()
    //         ApiCallGetAllocations(jobMonth, jobYear) // Reset to page 1 when month changes
    //         return newDate
    //     })
    // }

    // const handleNextMonth = () => {
    //     setCurrentDate((prevDate) => {
    //         const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
    //         const jobMonth = newDate.getMonth() + 1
    //         const jobYear = newDate.getFullYear()
    //         ApiCallGetAllocations(jobMonth, jobYear) // Reset to page 1 when month changes
    //         return newDate
    //     })
    // }

    // const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const newDate = new Date(event.target.value + "-01")
    //     setCurrentDate(newDate)

    //     // Call API with the new date
    //     const jobMonth = newDate.getMonth() + 1
    //     const jobYear = newDate.getFullYear()
    //     ApiCallGetAllocations(jobMonth, jobYear) // Reset to page 1 when date changes
    // }

    // const formatDate = (date: Date) => {
    //     return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
    // }

    // useEffect(() => {
    //     const fetchData = async () => {
    //         // const currentDate = new Date()
    //         const jobMonth = currentDate.getMonth() + 1
    //         const jobYear = currentDate.getFullYear()
    //         debouncedVenue && await ApiCallGetAllocations(jobMonth, jobYear) // Start with page 1
    //         //await ApiCallGetVenueList()
    //         debouncedVenue && await handleGetClientList()
    //     }
    //     fetchData()
    //     return () => { }
    // }, [debouncedVenue, page, rowsPerPage, selectedShopperName])

    useEffect(() => {
        selectedClientName && setSelectedClient(selectedClientName)
    }, [selectedClientName])


    // Updated useEffect to handle client changes
    useEffect(() => {
        if (selectedClient) {
            const jobYear = selectedDate.getFullYear()
            clientEntityId && ApiCallGetAllocations(jobYear)
        }
    }, [clientEntityId])

    // const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
    //     let data = `?offset=0&limit=500`
    //     if (clientEntityId) {
    //         data += `&clientEntityId=${clientEntityId}&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
    //     } else if (selectedClient?.clientGroupName) {
    //         data += `&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
    //     }
    //     const res = await ApiGetVenueList(data)
    //     const response = res?.data.map((item) => ({
    //         label: item.venueName,
    //         value: item.venueId,
    //         state: item.state,
    //         entityTypeName: item.entityTypeName
    //     }))
    //     setVenueName(response)
    // }

    // useEffect(() => {
    //     if (debouncedClientEntityId || selectedClient?.clientGroupName) {
    //         ApiCallGetVenueList(debouncedClientEntityId)
    //     } else {
    //         setVenueName([]) // Clear venue list when business is cleared
    //         setVenueNameValue(null) // Also clear selected venue
    //     }
    // }, [debouncedClientEntityId, selectedClient?.clientGroupName])

    useEffect(() => {
        // const jobMonth = currentDate.getMonth() + 1
        const jobYear = selectedDate.getFullYear()
        searchText.length > 0 && ApiCallGetAllocations(jobYear)
    }, [searchText])

    useEffect(() => {
        if (selectedClient?.clientGroupName) {
          handleGetClientList()
        }
      }, [selectedClient?.clientGroupName])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
        if (!selectedClient?.clientGroupName) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            setClientEntityList(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }
    useEffect(() => {
        if (selectedClient && selectedDate) { ApiCallGetAllocations(selectedDate.getFullYear()) }
    }, [selectedDate, selectedClient])

    const ApiCallGetAllocations = async (year: any) => {
        setAllocations([])
        setisStartLoading(true)
        store.dispatch(setLoadingTrue());
        let data = `?offset=${page * rowsPerPage}&userId=${selectedShopperId}${clientEntityId ? `&clientEntityId=${clientEntityId}` : ""}&limit=${rowsPerPage}&year=${year}${selectedClient?.clientGroupName ? `&allocationClientGroup=${selectedClient.clientGroupName}` : ''}`
        try {
            const res: any = await ApiGetResetAllocationList(data)
            setAllocations(res?.results || [])

            if (res?.totalRecords !== undefined) {
                setdatalength(res.totalRecords)
                setSelectAll(false)
                setSelectedAllocations([])
            }

        } catch (error) {
            console.error("Error during API call:", error)
        }
        finally {
            store.dispatch(setLoadingFalse());
            setisStartLoading(false)
        }
    }

    const handleSelectCard = (id: string, userId: string | number) => {
        if (selectedAllocations.some(item => item.allocationId === id && item.userId === userId)) {
            setSelectedAllocations(
                selectedAllocations.filter(item => !(item.allocationId === id && item.userId === userId))
            );
        } else {
            setSelectedAllocations([
                ...selectedAllocations,
                { allocationId: id, userId: userId }
            ]);
        }
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedAllocations([]); // clear all
        } else {
            setSelectedAllocations(
                allocations.map(a => ({
                    allocationId: a?.allocationId,
                    userId: a?.userId?.userId
                }))
            ); // select all with both allocationId + userId
        }
        setSelectAll(!selectAll);
    };
    const handleUpateDetails = async () => {
        // setshowdateselect(true)
        try {
            const data = {
                allocations: selectedAllocations,
            }
            const res = await ApiResetBulkAllocation(data)
            if (res) {
                toast.success("Allocatios moved successfully")
            }
            setshowdateselect(false)
            ApiCallGetAllocations(selectedDate.getFullYear())
        } catch (error) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                String(error);
            toast.error(message)
        }
    }

    // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    useEffect(
        () => {
            ApiCallGetAllocations(selectedDate.getFullYear())
        }, [selectedShopperName, clientEntityId])
    return (
        <div>
            <Box sx={{ p: 4 }} style={{ background: "white" }}>
                <Stack spacing={3}>
                    <Box sx={{ width: "100%" }}>
                        <h1 className="common-manage-h1" style={{ textAlign: "center" }}>
                            Bulk Shopper Reset
                        </h1>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "-70px",
                                marginTop: "23px",
                            }}
                        >
                            <Stack direction="row" spacing={2}>
                                <FormControl size="small" sx={{ width: 180 }}>
                                    <Autocomplete
                                        disablePortal
                                        id="mm-autocomplete"
                                        options={Clientlist}
                                        value={selectedClient}
                                        getOptionLabel={(option) => option?.clientGroupName}
                                        isOptionEqualToValue={(option, value) => option.clientGroupDBName === value.clientGroupDBName}
                                        onChange={(event, newValue: any) => {
                                            // setSelectedClient(newValue)
                                            dispatch(setSelectedClientGroup(newValue))
                                            setClientId(newValue?.clientGroupName || null)
                                            setClientEntityId(null)
                                            setVenueNameValue(null)
                                            setClientEntityList([])
                                        }}
                                        // defaultValue="mmcommon"
                                        renderInput={(params) => <TextField {...params} label="Select Client" />}
                                        size="small"
                                    />
                                </FormControl>
                                <FormControl size="small" sx={{ width: 180 }}>
                                    <Autocomplete
                                        disablePortal
                                        id="beacon-autocomplete"
                                        options={clientEntityList.filter((item) => item.clientEntityId !== null)}
                                        getOptionLabel={(option) => option?.entityName || ""}
                                        onChange={(event, newValue: any) => {
                                            setClientEntityId(newValue?.clientEntityId || null)
                                            if (!newValue) {
                                                setVenueNameValue(null)
                                            }
                                        }}
                                        value={clientEntityList.find((option) => option?.clientEntityId === clientEntityId) || null}
                                        renderInput={(params) => <TextField {...params} label="Select Business" />}
                                        size="small"
                                    />
                                </FormControl>
                                {/* <FormControl size="small" sx={{ width: 250 }}>
                                    <Autocomplete
                                        disablePortal
                                        id="mm-autocomplete"
                                        options={venueName}
                                        getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                                        value={venueName.find((option: any) => option.value === venueNameValue) || null}
                                        onChange={(event, newValue: any) => {
                                            setVenueNameValue(newValue?.value || null)
                                            setSearchText("")
                                        }}
                                        defaultValue=""
                                        renderInput={(params) => <TextField {...params} label="Search Site" />}
                                        size="small"
                                    />
                                </FormControl> */}
                            </Stack>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginBottom: "70px",
                                }}
                            >
                                {/* <IconButton onClick={handlePrevMonth}>
                                    <ChevronLeftIcon />
                                </IconButton>
                                <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                                    <input
                                        type="month"
                                        value={formatDate(currentDate)}
                                        onChange={handleDateChange}
                                        className="primary-color"
                                        style={{
                                            border: "none",
                                            background: "none",
                                            fontSize: "1.25rem",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            fontFamily: "inherit",
                                        }}
                                    />
                                </Box>
                                <IconButton onClick={handleNextMonth}>
                                    <ChevronRightIcon />
                                </IconButton> */}
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        views={["year"]}
                                        label="Select Year"
                                        value={selectedDate}
                                        onChange={(newValue) => newValue && setSelectedDate(newValue)}
                                        sx={{ width: 250 }}
                                    />
                                </LocalizationProvider>
                            </Box>
                            <Stack direction="row" spacing={2} sx={{ marginRight: 4 }}>
                                <Box width={'500px'} sx={{ position: 'relative' }}>
                                    <TextField
                                        fullWidth
                                        label="Search and Select Shopper"
                                        value={selectedShopperId ? selectedShopperName : searchQuery}
                                        onChange={(e) => {
                                            setSearchQuery(e.target.value);
                                            if (!e.target.value) {
                                                setSelectedShopperId('');
                                                setSelectedShopperName('');
                                            }
                                        }}
                                        onFocus={() => searchQuery && setShowDropdown(true)}
                                        InputProps={{
                                            endAdornment: selectedShopperId && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() => {
                                                        setSelectedShopperId('');
                                                        setSelectedShopperName('');
                                                        setSearchQuery('');
                                                    }}
                                                >
                                                    <CancelOutlined fontSize="small" />
                                                </IconButton>
                                            )
                                        }}
                                    />
                                    {showDropdown && shopperList.length > 0 && (
                                        <Box sx={{
                                            position: 'absolute',
                                            top: '100%',
                                            left: 0,
                                            right: 0,
                                            zIndex: 9999,
                                            bgcolor: 'background.paper',
                                            maxHeight: 250,
                                            overflow: 'auto',
                                            border: '1px solid #ccc',
                                            boxShadow: 3,

                                        }}>
                                            {shopperList.map((shopper) => (
                                                <MenuItem
                                                    key={shopper.userId}
                                                    onClick={() => {
                                                        setSelectedShopperId(shopper.userId);
                                                        setSelectedShopperName(`${shopper.firstName} ${shopper.lastName} (${shopper.userName}) (${shopper.emailId}) (${shopper.contactNo})`);
                                                        setSearchQuery('');
                                                        setShowDropdown(false);
                                                    }}
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        '&:hover': { bgcolor: '#f5f5f5' }
                                                    }}
                                                >
                                                    <span>{shopper.firstName} {shopper.lastName} ({shopper.userName}) ({shopper.emailId}) ({shopper.contactNo})</span>
                                                </MenuItem>
                                            ))}
                                        </Box>
                                    )}
                                </Box>
                            </Stack>
                        </Box>
                    </Box>

                    <Box className='d-flex align-items-center justify-content-end mr-4 mb-3'>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="table-row-background"
                            onClick={() => {
                                const isConfirmed = window.confirm("Are You Sure You Want to Reset ?")
                                if (isConfirmed) {
                                    handleUpateDetails()
                                }
                            }}
                        >
                            Bulk Reset
                        </Button>
                    </Box>
                </Stack>
                <Box>
                    <TableContainer
                        component={Paper}
                        sx={{ mb: 4, border: "1px solid #ccc" }}
                    >
                        <Table>
                            <TableHead sx={{ bgcolor: "#7a7d52" }}>
                                <TableRow>
                                    <TableCell padding="checkbox" sx={{ color: "white" }}>
                                        <Checkbox
                                            checked={selectAll}
                                            onChange={handleSelectAll}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ color: 'white' }}>ID</TableCell>
                                    <TableCell sx={{ color: 'white' }}>Status</TableCell>
                                    <TableCell sx={{ color: 'white' }}>Store Name</TableCell>
                                    <TableCell sx={{ color: 'white' }}>Group Name</TableCell>
                                    <TableCell sx={{ color: 'white' }}>Type</TableCell>
                                    <TableCell sx={{ color: 'white' }}>Shopper Name</TableCell>
                                    <TableCell sx={{ color: 'white' }}>Visit Date</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {selectedShopperId ? (
                                    allocations?.length > 0 ? (
                                        allocations.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell padding="checkbox" sx={{ color: "white" }}>
                                                    <Checkbox
                                                        checked={selectedAllocations.some(
                                                            (selected) =>
                                                                selected.allocationId === item?.allocationId &&
                                                                selected.userId === item?.userId?.userId
                                                        )}
                                                        onChange={() =>
                                                            handleSelectCard(item?.allocationId, item?.userId?.userId)
                                                        }
                                                    />
                                                </TableCell>
                                                <TableCell>{item?.allocationId}</TableCell>
                                                <TableCell>{item?.allocationStatusId?.statusDesc}</TableCell>
                                                <TableCell>{item?.venueId?.venueName}</TableCell>
                                                <TableCell>{item?.allocationClientGroup}</TableCell>
                                                <TableCell>{item?.venueId?.clientEntityId?.entityTypeId?.entityTypeName}</TableCell>
                                                <TableCell
                                                    sx={{ cursor: "pointer" }}
                                                    onClick={(e) => {
                                                        if (item?.userId?.userId) {
                                                            handleShopperDetailsClick(e, item?.userId?.userId)
                                                        }
                                                    }}
                                                >
                                                    {item?.userId?.firstName} {item?.userId?.lastName}
                                                </TableCell>
                                                <TableCell>
                                                    {dayjs(item?.appliedAllocations[0]?.selectedVisitDate).format("DD/MM/YYYY")}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={8} sx={{ textAlign: "center", fontWeight: "bolder", color: "red" }}>No Data Found</TableCell>
                                        </TableRow>
                                    )
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={8} sx={{ textAlign: "center", fontWeight: "bolder", color: "red" }}>Please Select Shopper</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            component="div"
                            count={datalength}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>

                </Box>

            </Box>

            {isStartLoading && (
                <div
                    className="loader-overlay"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        // background: 'rgba(0, 0, 0, 0.8)',
                        zIndex: 9999,
                    }}
                >
                    <div
                        style={{
                            border: '4px solid rgba(103, 107, 65, 1)',
                            borderRadius: '50%',
                            borderTop: '4px solid white',
                            width: 35,
                            height: 35,
                            animation: 'spin 0.6s linear infinite',
                        }}
                    ></div>

                    {/* Add animation style manually */}
                    <style>
                        {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
                    </style>
                </div>
            )}
            <Popover
                // open={Boolean(anchorEl) && selectedIndex === index}
                open={Boolean(anchorEl) && clickedShopperId !== null}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <Dcrage handleClose={handleClose} loanData={loanData} />
            </Popover>
        </div >
    )
}